/**
 * Shared Legal Pages Component Constants
 * Centralized styling and configuration for consistency across Privacy and Terms pages
 */

export const LEGAL_TYPOGRAPHY = {
  h2: "text-3xl font-bold mb-8 font-display",
  h3: "text-xl font-semibold mb-6",
  paragraph: "text-lg mb-6 leading-relaxed",
  paragraphWithOpacity: "text-lg mb-8 opacity-80 leading-relaxed",
  listItem: "leading-relaxed",
  smallText: "text-sm opacity-70 mb-4",
} as const;

export const LEGAL_SPACING = {
  sectionBottom: "mb-8",
  subsectionBottom: "mb-6",
  listSpacing: "space-y-4",
  cardPadding: "p-8 md:p-12",
  highlightPadding: "p-6",
} as const;

export const LEGAL_BACKGROUNDS = {
  highlight: "p-6 rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border-l-4 border-opacity-50",
  warning: "p-6 rounded-lg bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-500",
  success: "p-6 rounded-lg bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500",
} as const;

export const LEGAL_ANIMATION = {
  duration: 0.6,
  ease: "easeOut",
  viewport: { once: true, margin: "-50px" },
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
} as const; 